import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import QuickPickTester from "./components/QuickPickTester";
import QuickPickWidget from "./components/QuickPickWidget";
import PixTickerPage from "./components/PixTicker";
import BetMaker from "./components/BetMaker";
import ExactaValue from "./pages/ExactaValue";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import ChangePasswordPage from "./pages/ChangePasswordPage";
import PricingPage from "./pages/PricingPage";
import SubscriptionSuccessPage from "./pages/SubscriptionSuccessPage";
import AdminPage from "./pages/AdminPage";
import AffiliateDashboard from "./pages/AffiliateDashboard";
import MyDownloadsPage from "./pages/MyDownloadsPage";
import { Toaster } from "./components/ui/sonner";
import UpdateBanner from "./components/UpdateBanner";
import GlobalMessageBanner from "./components/GlobalMessageBanner";
import FreeAccessBanner from "./components/FreeAccessBanner";
import TriBetDashboardPage from "./pages/TriBetDashboardPage";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="top-center" richColors />
        <UpdateBanner />
        <GlobalMessageBanner />
        <FreeAccessBanner />
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/change-password" element={<ChangePasswordPage />} />
            
            {/* Widget route (for embedded use - no auth) */}
            <Route path="/widget" element={<QuickPickWidget />} />

            {/* PixTicker — public embeddable CNBC-style ticker (no auth) */}
            <Route path="/pixticker" element={<PixTickerPage />} />
            
            {/* Pricing page - requires auth but not subscription */}
            <Route 
              path="/pricing" 
              element={
                <ProtectedRoute requireSubscription={false}>
                  <PricingPage />
                </ProtectedRoute>
              } 
            />
            
            {/* Subscription success page - requires auth but not subscription */}
            <Route 
              path="/subscription/success" 
              element={
                <ProtectedRoute requireSubscription={false}>
                  <SubscriptionSuccessPage />
                </ProtectedRoute>
              } 
            />
            
            {/* Admin page - requires auth (admin check done in component) */}
            <Route 
              path="/admin" 
              element={
                <ProtectedRoute requireSubscription={false}>
                  <AdminPage />
                </ProtectedRoute>
              } 
            />
            
            <Route
              path="/tribet"
              element={
                <ProtectedRoute requireSubscription={false}>
                  <TriBetDashboardPage />
                </ProtectedRoute>
              }
            />

            {/* Affiliate dashboard - requires auth (affiliate check done in component) */}
            <Route 
              path="/affiliate" 
              element={
                <ProtectedRoute requireSubscription={false}>
                  <AffiliateDashboard />
                </ProtectedRoute>
              } 
            />
            
            {/* My Downloads - user-facing download history (requires auth) */}
            <Route 
              path="/my-downloads" 
              element={
                <ProtectedRoute requireSubscription={false}>
                  <MyDownloadsPage />
                </ProtectedRoute>
              } 
            />
            
            {/* Protected routes - require authentication */}
            <Route 
              path="/" 
              element={
                <ProtectedRoute requireSubscription={true}>
                  <QuickPickTester />
                </ProtectedRoute>
              } 
            />

            {/* BetMaker - gated by per-user betmaker_enabled flag (admins always) */}
            <Route 
              path="/betmaker" 
              element={
                <ProtectedRoute requireBetmaker={true}>
                  <BetMaker />
                </ProtectedRoute>
              } 
            />

            {/* Exacta Value - gated by per-user exacta_value_enabled flag (admins always) */}
            <Route 
              path="/exacta-value" 
              element={
                <ProtectedRoute requireExactaValue={true}>
                  <ExactaValue />
                </ProtectedRoute>
              } 
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
